export const authEndpoints = {
  authUser: '/admin/auth/me', // GET
  signIn: '/admin/auth/sign-in', // POST
  validateSocialSignIn: '/auth/validate-social-sign-in', // POST
  forgotPassword: '/admin/auth/forgot-password', // PUT
  resetPassword: '/admin/auth/reset-password', // PUT
  getAccessToken: '/admin/auth/access-token', // GET
  signOut: '/admin/auth/sign-out', // GET
}

export const authBackendErrors = {
  ADMIN_AUTH_USER_NOT_FOUND: 'Kullanıcı bulunamadı!',
  ADMIN_AUTH_UPDATE: 'İşlem gerçekleştirilemedi. Lütfen tekrar deneyin.',
  ADMIN_AUTH_INVALID_RESET_PASSWORD_TOKEN:
    'Sıfırlama bağlantısı geçersiz veya süresi dolmuş.',
  AUTH_PASSWORD_CONTAINS_SPACE: 'Şifre boşluk içeremez.',
  AUTH_PASSWORD_TOO_SHORT: 'Şifre çok kısa.',
  AUTH_PASSWORD_MISSING_UPPERCASE: 'Şifre en az bir büyük harf içermelidir.',
  AUTH_PASSWORD_MISSING_LOWERCASE: 'Şifre en az bir küçük harf içermelidir.',
  AUTH_PASSWORD_MISSING_DIGIT: 'Şifre en az bir rakam içermelidir.',
  AUTH_PASSWORD_MISSING_SPECIAL_CHAR:
    'Şifre en az bir özel karakter içermelidir.',
  ADMIN_AUTH_USER_NOT_ADMIN: 'Bu hesap admin değil!',
  ADMIN_AUTH_INVALID_CREDENTIALS: 'E-posta veya şifre hatalı!',
  ADMIN_AUTH_INVALID_SIGN_IN_METHOD:
    'Bu hesap sosyal giriş ile oluşturulduğu için e-posta/şifre ile giriş yapamaz.',
  AUTH_INVALID_SIGN_IN_METHOD:
    'Bu hesap sosyal giriş ile oluşturulduğu için e-posta/şifre ile giriş yapamaz.',
  USER_EMAIL_PASSWORD_SIGNIN_NOT_ALLOWED:
    'Bu hesap sosyal giriş ile oluşturulduğu için e-posta/şifre ile giriş yapamaz.',
  ADMIN_PROFILE_INVALID_EMAIL_VERIFICATION_TOKEN:
    'Geçersiz e-posta doğrulama isteği!',
  GENERAL_ERROR: 'Beklenemeyen bir hata oluştu!',
} as const

export const authSuccessMessages = {
  signIn: (name: string) => `Hoşgeldin ${name}!`,
  emailVerify: 'E-posta doğrulandı. Girişe yönlendiriliyorsunuz.',
}
